import { useFetchLoans } from '../../../hooks/loan/useFetchLoans';
import Page from '../../../layout/components/Page';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIndicator from '../../Common/LoadingIndicator';
import { InvestorLoanCard } from './InvestorLoanCard';
import Modal from '../../Common/Modal';
import LoanTypeFilter from '../../Common/LoanTypeFilter';
import { CountryFilter } from '../../Common/CountryFilter';
import Paginate from '../../Common/Paginate';

const InvestorLoans = () => {
  const { showForm, loanTypes, countrySelection, page, menu, loading, openLoans, pagination, pageQuery, updateLoanTypeValues, updateCountryValues, handleFilterLoan, toggleForm } = useFetchLoans();

  const renderChildren = (
    <>
      <button className='btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder me-2' onClick={toggleForm}>
        <i className='bi bi-filter'></i>
        Filter Loans
      </button>
    </>
  );
  return (
    <Page
      title="View Loans"
      icon="bi-briefcase"
      toolbarChildren={renderChildren}
    >
      <div className="row">
        {openLoans && openLoans.length ? (
          <>
            {openLoans.map((loan, index) => (
              <InvestorLoanCard key={index} loan={loan} />
            ))}
            {pagination && (
              <Paginate
                pagination={pagination}
                pageLink={`/loans/${menu}`}
                pageQuery={pageQuery}
              />
            )}
          </>
        ) : null}
        {!openLoans && <LoadingIndicator message="" />}
        {openLoans && !openLoans.length && (
          <div className="d-flex justify-content-center align-item-center">
            <div className="text-center pt-20 pb-20">
              <i className="bi bi-folder" style={{ fontSize: "3.5em" }}></i>
              <p className="text-muted ms-20p me-20p pt-3 pb-3">
                There are no loans matching your search.
              </p>
            </div>
          </div>
        )}
      </div>

      <Modal show={showForm} toggle={toggleForm} title="Filter Loan">
        <label className="fs-8 text-muted">Loan Type</label>
        <LoanTypeFilter
          defaultValues={loanTypes}
          updateSelectedValue={updateLoanTypeValues}
        />
        <label className="fs-8 text-muted mt-3">Country</label>
        <CountryFilter
          defaultValues={countrySelection}
          updateSelectedValue={updateCountryValues}
        />
        <button
          className="btn btn-sm btn-light-primary fw-bolder text-center mt-10 align-center"
          data-kt-menu-dismiss="true"
          onClick={handleFilterLoan}
        >
          Apply
        </button>
      </Modal>
    </Page>
  );
};

export default InvestorLoans;
